var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content" },
    [
      _vm.modal
        ? _c("app-modal-visualiza-pdf", {
            attrs: { titulo: _vm.titulo, bytes: _vm.byte },
            on: { closeModal: _vm.fecharModal }
          })
        : _vm._e(),
      _c("h1", { staticClass: "titulo" }, [_vm._v("Legislações")]),
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.abaAtiva,
            callback: function($$v) {
              _vm.abaAtiva = $$v
            },
            expression: "abaAtiva"
          }
        },
        [
          _c(
            "el-collapse-item",
            {
              attrs: {
                title: "LEGISLAÇÃO AMBIENTAL APLICADA À REGULARIZAÇÃO FUNDIÁRIA"
              }
            },
            [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { type: "text", index: "key" },
                    on: {
                      click: function($event) {
                        return _vm.visualizar(
                          "Constituição Estadual do Estado do Pará - Meio Ambiente.pdf"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Constituição Estadual do Estado do Pará - Meio Ambiente"
                    )
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { type: "text", index: "key" },
                    on: {
                      click: function($event) {
                        _vm.visualizar(
                          "Lei nº6.938 de 31 de agosto de 1981 (Dispõe sobre a Política Nacional do Meio Ambiente).pdf"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Lei nº6.938, de 31 de agosto de 1981 (Dispõe sobre a Política Nacional do Meio Ambiente)"
                    )
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { type: "text", index: "key" },
                    on: {
                      click: function($event) {
                        _vm.visualizar(
                          "Lei nº11.284 de 2 de março de 2006 (Lei de Gestão de Florestas Públicas).pdf"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Lei nº11.284, de 2 de março de 2006 (Lei de Gestão de Florestas Públicas)"
                    )
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { type: "text", index: "key" },
                    on: {
                      click: function($event) {
                        _vm.visualizar(
                          "Lei nº12.651 de 25 de maio de 2012 (Código Florestal).pdf"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Lei nº12.651, de 25 de maio de 2012 (Código Florestal)"
                    )
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { type: "text", index: "key" },
                    on: {
                      click: function($event) {
                        return _vm.visualizar(
                          "Decreto Estadual nº1.148 de 17 de julho de 2008.pdf"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Decreto Estadual nº1.148, de 17 de julho de 2008 (Dispõe sobre o cadastro ambiental rural-CAR-PA, área de reserva legal e dá outras providências)"
                    )
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { type: "text", index: "key" },
                    on: {
                      click: function($event) {
                        return _vm.visualizar(
                          "Decreto nº8.235 de 5 de maio de 2014.pdf"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Decreto nº8.235, de 5 de maio de 2014 (estabelece normas gerais complementares aos Programas de Regularização Ambiental dos Estados e do Distrito Federal - PRA)"
                    )
                  ]
                )
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: { type: "text", index: "key" },
                    on: {
                      click: function($event) {
                        return _vm.visualizar(
                          "Decreto Estadual nº1.379 de 3 de setembro de 2015.pdf"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "Decreto Estadual nº1.379, de 3 de setembro de 2015 (cria o Programa de Regularização Ambiental dos Imóveis Rurais do Estado do Pará-PRA/PA e dá outras providências)"
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.abaAtiva,
            callback: function($$v) {
              _vm.abaAtiva = $$v
            },
            expression: "abaAtiva"
          }
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "LEGISLAÇÃO FUNDIÁRIA ESTADUAL EM VIGOR" } },
            [
              _c(
                "ul",
                [
                  _c("li", [
                    _c("h3", [
                      _vm._v(
                        "Atos da Corregedoria de Justiça do Estado do Pará referente aos registros de imóveis"
                      )
                    ])
                  ]),
                  _c("ul", [
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { type: "text", index: "key" },
                          on: {
                            click: function($event) {
                              return _vm.visualizar(
                                "Provimento 02-2010-Dispõe sobre a averbação de CANCELAMENTO das matrículas imobiliárias bloqueadas.pdf"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "Provimento 02-2010-Dispõe sobre a averbação de CANCELAMENTO das matrículas imobiliárias bloqueadas"
                          )
                        ]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { type: "text", index: "key" },
                          on: {
                            click: function($event) {
                              return _vm.visualizar(
                                "Provimento 10-2012- dispõe sobre o procedimento de REQUALIFICAÇÃO das matrículas imobiliárias.pdf"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "Provimento 10-2012- dispõe sobre o procedimento de REQUALIFICAÇÃO das matrículas imobiliárias"
                          )
                        ]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { type: "text", index: "key" },
                          on: {
                            click: function($event) {
                              return _vm.visualizar(
                                "Provimento 013-2006 - Dispõe sobre a averbação de BLOQUEIO de Matrículas de áreas rurais.pdf"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "Provimento 013-2006 - Dispõe sobre a averbação de BLOQUEIO de Matrículas de áreas rurais nos Cartórios do Registro de Imóveis nas Comarcas do Interior e dá outras providências."
                          )
                        ]
                      )
                    ]),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: { type: "text", index: "key" },
                          on: {
                            click: function($event) {
                              return _vm.visualizar(
                                "Pedido de Providência nº0001943-67.2009.2.00.0000 do CNJ.pdf"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "Pedido de Providência nº0001943-67.2009.2.00.0000 do CNJ (Determinou o Cancelamento das Matrículas Imobiliárias do Estado do Pará)"
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("li", [
                    _c("h3", [
                      _vm._v("Demais atos normativos do Poder Executivo")
                    ])
                  ]),
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.abaAtiva,
                        callback: function($$v) {
                          _vm.abaAtiva = $$v
                        },
                        expression: "abaAtiva"
                      }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "Assentamentos" } },
                        [
                          _c(
                            "ul",
                            _vm._l(_vm.assentamentos, function(file, key) {
                              return _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { type: "text", index: "key" },
                                    on: {
                                      click: function($event) {
                                        return _vm.visualizar(file.nameServer)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(file.name))]
                                )
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.abaAtiva,
                        callback: function($$v) {
                          _vm.abaAtiva = $$v
                        },
                        expression: "abaAtiva"
                      }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "Quilombos" } },
                        [
                          _c(
                            "ul",
                            _vm._l(_vm.quilombos, function(file, key) {
                              return _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: { type: "text", index: "key" },
                                    on: {
                                      click: function($event) {
                                        return _vm.visualizar(file.nameServer)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(file.name))]
                                )
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("li", [
                    _c("h3", [_vm._v("Instruções Normativas")]),
                    _c(
                      "ul",
                      _vm._l(_vm.instrucoes, function(file, key) {
                        return _c("li", [
                          _c(
                            "a",
                            {
                              attrs: { type: "text", index: "key" },
                              on: {
                                click: function($event) {
                                  return _vm.visualizar(file.nameServer)
                                }
                              }
                            },
                            [_vm._v(_vm._s(file.name))]
                          )
                        ])
                      }),
                      0
                    )
                  ]),
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { type: "text", index: "key" },
                        on: {
                          click: function($event) {
                            return _vm.visualizar(
                              "Constituição do Estado do Pará- Agrário.pdf"
                            )
                          }
                        }
                      },
                      [_vm._v("Constituição do Estado do Pará - Agrário")]
                    )
                  ]),
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { type: "text", index: "key" },
                        on: {
                          click: function($event) {
                            return _vm.visualizar(
                              "Constituição Federal - Agrário.pdf"
                            )
                          }
                        }
                      },
                      [_vm._v("Constituição Federal - Agrário")]
                    )
                  ]),
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { type: "text", index: "key" },
                        on: {
                          click: function($event) {
                            _vm.visualizar(
                              "Lei n° 8.972-2020(Regula o processo administrativo no âmbito da Administração Pública do Estado do Pará).pdf"
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "Lei n° 8.972-2020 (Regula o processo administrativo no âmbito da Administração Pública do Estado do Pará)"
                        )
                      ]
                    )
                  ]),
                  _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { type: "text", index: "key" },
                        on: {
                          click: function($event) {
                            _vm.visualizar(
                              "lei nº8.878-2019( Nova Lei de Terras do Estado do Pará).pdf"
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "lei nº8.878-2019 (Nova Lei de Terras do Estado do Pará)"
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.abaAtiva,
            callback: function($$v) {
              _vm.abaAtiva = $$v
            },
            expression: "abaAtiva"
          }
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "LEGISLAÇÃO FUNDIÁRIA FEDERAL EM VIGOR" } },
            [
              _c(
                "ul",
                _vm._l(_vm.legislacaoFederal, function(file, key) {
                  return _c("li", [
                    _c(
                      "a",
                      {
                        attrs: { type: "text", index: "key" },
                        on: {
                          click: function($event) {
                            return _vm.visualizar(file.nameServer)
                          }
                        }
                      },
                      [_vm._v(_vm._s(file.name))]
                    )
                  ])
                }),
                0
              )
            ]
          )
        ],
        1
      ),
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.abaAtiva,
            callback: function($$v) {
              _vm.abaAtiva = $$v
            },
            expression: "abaAtiva"
          }
        },
        [
          _c("el-collapse-item", { attrs: { title: "PERÍODO REPUBLICANO" } }, [
            _c(
              "ul",
              _vm._l(_vm.periodoRepublicano, function(file, key) {
                return _c("li", [
                  _c(
                    "a",
                    {
                      attrs: { type: "text", index: "key" },
                      on: {
                        click: function($event) {
                          return _vm.visualizar(file.nameServer)
                        }
                      }
                    },
                    [_vm._v(_vm._s(file.name))]
                  )
                ])
              }),
              0
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c1aadf4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1aadf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/ConsultaLegislacao.vue
// module id = null
// module chunks = 